import { initAccordionAnimation } from "./enhancements/accordion-animation";
import { initFrontpageCard2IconGradients } from "./enhancements/frontpage-cards-2";
import { initHeroAnimations } from "./enhancements/hero-animations";
import { initHimmlCardsMotion } from "./enhancements/himml-cards-motion";
import { initMobileNavigation } from "./enhancements/mobile-navigation";
import { initMobileHeader } from "./enhancements/mobile-header";
import { getMotionEnabled } from "./enhancements/motion";

const initThemeInteractions = () => {
  const motionEnabled = getMotionEnabled();

  initMobileHeader();
  initMobileNavigation();
  initFrontpageCard2IconGradients();
  initHeroAnimations({ motionEnabled });
  initHimmlCardsMotion({ motionEnabled });
  initAccordionAnimation({ motionEnabled });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initThemeInteractions);
} else {
  initThemeInteractions();
}
